import AuthPolicyWarn from './AuthPolicyWarn'

export default AuthPolicyWarn